var $92cc56d08ee03766$exports = {};
$92cc56d08ee03766$exports = {
    "pending": `\xeen a\u{219}teptare`
};


export {$92cc56d08ee03766$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
